/**
 * WordPress CSS classes and IDs.
 *
 * @type {string}
 */

// CSS classes.
export const currentSubMenuClass = 'wp-has-current-submenu';
export const hasSubMenuClass     = 'wp-has-submenu';
export const menuNameClass       = 'wp-menu-name';
export const menuTopClass        = 'menu-top';

// IDs.
export const adminMenuWrapId = 'adminmenuwrap';
export const adminMenuId     = 'adminmenu';